module.exports = {
  defaultCountry: 'CZ',
  defaultLocale: 'cs',
  domainCode: 'ventilatory-shop.cz',
  fallbackLocale: 'cs',
  locales: 'cs',
  theme: 'cvb',
}
